export enum EventType {
  SPOT_EVENT,
  CURVE_EVENT,
}

export namespace EventType {
  let elements = [EventType.SPOT_EVENT, EventType.CURVE_EVENT];
  let alias = "com.bcdfx.streaming.EventType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
